/* eslint-disable camelcase */
import { DaoModel } from '@dynameat/models';

export class ProductRecommendation extends DaoModel {
  constructor(guid, order, is_visible, special, special_frame, nameAlt1, nameAlt2, nameAlt3) {
    super(guid);
    this.order = order || 0;
    this.is_visible = is_visible;
    this.special = special || false;
    this.special_frame = special_frame || false;
    this.recommendation_order = this.order;
    this.recommendation_is_visible = this.is_visible;
    this.recommendation_special = this.special;
    this.recommendation_special_frame = this.special_frame;
    this.nameAlt1 = nameAlt1;
    this.nameAlt2 = nameAlt2;
    this.nameAlt3 = nameAlt3;
  }

  static toInstance(props = {}) {
    return new ProductRecommendation(props.guid, props.order, props.is_visible, props.special,
      props.special_frame, props.name_alt1, props.name_alt2, props.name_alt3);
  }

  serialize() {
    return {
      ...super.serialize(),
      name_alt1: this.nameAlt1,
      name_alt2: this.nameAlt2,
      name_alt3: this.nameAlt3,
      order: this.order,
      is_visible: this.is_visible,
      special: this.special,
      special_frame: this.special_frame,
    };
  }

  get name() {
    return this.nameAlt1;
  }

  hasChange() {
    return this.order !== this.recommendation_order
      || this.is_visible !== this.recommendation_is_visible
      || this.special !== this.recommendation_special
      || this.special_frame !== this.recommendation_special_frame;
  }
}
